export const UsdRestrictions = {
	"2026-05-19": {
		high: 23.50159085,
		low: 15.33522516
	},
	"2026-05-18": {
		high: 23.27801187,
		low: 14.79060968
	},
	"2026-05-15": {
		high: 23.63133403,
		low: 15.38824438
	},
	"2026-05-14": {
		high: 23.93865881,
		low: 15.61254549
	},
	"2026-05-13": {
		high: 24.48268604,
		low: 16.08372829
	},
	"2026-05-12": {
		high: 24.52277021,
		low: 16.18056913
	},
	"2026-05-11": {
		high: 25.21958431,
		low: 16.58694959
	},
	"2026-05-08": {
		high: 24.96577203,
		low: 16.30193053
	},
	"2026-05-07": {
		high: 25.62376095,
		low: 16.74800851
	},
	"2026-05-06": {
		high: 24.49528937,
		low: 16.17389543
	},
	"2026-05-05": {
		high: 24.13151677,
		low: 15.76017869
	},
	"2026-05-04": {
		high: 25.13043977,
		low: 16.43254401
	},
	"2026-05-01": {
		high: 25.44676621,
		low: 16.69944033
	},
	"2026-04-30": {
		high: 25.34627235,
		low: 16.4367783
	},
	"2026-04-29": {
		high: 26.1641808,
		low: 17.21507458
	},
	"2026-04-28": {
		high: 26.7267871,
		low: 17.57086648
	},
	"2026-04-27": {
		high: 26.56934726,
		low: 17.48300981
	},
	"2026-04-24": {
		high: 26.83936268,
		low: 17.61842472
	},
	"2026-04-23": {
		high: 26.40492687,
		low: 17.24688507
	},
	"2026-04-22": {
		high: 26.63631678,
		low: 17.58002634
	},
	"2026-04-21": {
		high: 26.30988051,
		low: 17.34541372
	},
	"2026-04-20": {
		high: 25.85442175,
		low: 16.74250362
	},
	"2026-04-17": {
		high: 24.34431163,
		low: 16.0116949
	},
	"2026-04-16": {
		high: 24.22940608,
		low: 15.87226578
	},
	"2026-04-15": {
		high: 25.52953573,
		low: 16.77311141
	},
	"2026-04-14": {
		high: 25.50609018,
		low: 16.69064748
	},
	"2026-04-13": {
		high: 24.9255129,
		low: 16.26514571
	},
	"2026-04-10": {
		high: 24.91616246,
		low: 16.29448684
	},
	"2026-04-09": {
		high: 24.68586962,
		low: 16.2193922
	},
	"2026-04-08": {
		high: 24.99982393,
		low: 16.00732472
	},
	"2026-04-07": {
		high: 23.40254867,
		low: 15.18877861
	},
	"2026-04-02": {
		high: 23.31521401,
		low: 15.03512201
	},
	"2026-04-01": {
		high: 23.38779496,
		low: 15.20400601
	},
	"2026-03-31": {
		high: 21.71009053,
		low: 14.00419519
	},
	"2026-03-30": {
		high: 21.66287578,
		low: 14.18980022
	},
	"2026-03-27": {
		high: 22.54740313,
		low: 14.77328937
	},
	"2026-03-26": {
		high: 23.51855931,
		low: 15.29904174
	},
	"2026-03-25": {
		high: 23.89212696,
		low: 15.61130138
	},
	"2026-03-24": {
		high: 23.79020979,
		low: 15.44055944
	},
	"2026-03-23": {
		high: 22.9918567,
		low: 14.86817946
	},
	"2026-03-20": {
		high: 23.38663801,
		low: 15.40568443
	},
	"2026-03-19": {
		high: 24.24268192,
		low: 15.9803859
	},
	"2026-03-18": {
		high: 24.52074995,
		low: 15.93146549
	},
	"2026-03-17": {
		high: 24.22925322,
		low: 15.76648557
	},
	"2026-03-16": {
		high: 24.08262231,
		low: 15.72708058
	},
	"2026-03-13": {
		high: 23.73766281,
		low: 15.55149163
	},
	"2026-03-12": {
		high: 24.60898538,
		low: 16.10039402
	},
	"2026-03-11": {
		high: 25.34020781,
		low: 16.7161276
	},
	"2026-03-10": {
		high: 25.88471478,
		low: 16.92615453
	},
	"2026-03-09": {
		high: 25.41182462,
		low: 16.29050169
	},
	"2026-03-06": {
		high: 26.68297621,
		low: 17.45121197
	},
	"2026-03-05": {
		high: 26.54990016,
		low: 17.5205801
	},
	"2026-03-04": {
		high: 27.58464596,
		low: 17.56363919
	},
	"2026-03-03": {
		high: 28.36546238,
		low: 18.31391055
	},
	"2026-03-02": {
		high: 28.95677332,
		low: 19.02087588
	},
	"2026-02-27": {
		high: 29.85745583,
		low: 19.47250121
	},
	"2026-02-26": {
		high: 29.930523,
		low: 19.55017547
	},
	"2026-02-25": {
		high: 30.77997008,
		low: 20.15528172
	},
	"2026-02-24": {
		high: 29.62262687,
		low: 19.36462471
	},
	"2026-02-23": {
		high: 29.91874965,
		low: 19.52265418
	},
	"2026-02-20": {
		high: 30.08010879,
		low: 19.63975833
	},
	"2026-02-19": {
		high: 30.45672381,
		low: 19.9148804
	},
	"2026-02-18": {
		high: 30.45942616,
		low: 19.94578419
	},
	"2026-02-17": {
		high: 30.95145328,
		low: 20.36227623
	},
	"2026-02-16": {
		high: 31.28450549,
		low: 20.46047376
	},
	"2026-02-13": {
		high: 31.48893431,
		low: 20.61916921
	},
	"2026-02-12": {
		high: 32.01496981,
		low: 20.81596779
	},
	"2026-02-11": {
		high: 32.40053873,
		low: 19.81030563
	},
	"2026-02-10": {
		high: 28.21671866,
		low: 18.60175576
	},
	"2026-02-09": {
		high: 28.72702519,
		low: 18.87905605
	},
	"2026-02-06": {
		high: 28.01504013,
		low: 18.0705988
	},
	"2026-02-05": {
		high: 28.2333391,
		low: 18.52587848
	},
	"2026-02-04": {
		high: 28.42189227,
		low: 18.4833261
	},
	"2026-02-03": {
		high: 28.05982726,
		low: 18.4425251
	},
	"2026-02-02": {
		high: 27.49345245,
		low: 18.02330024
	},
	"2026-01-30": {
		high: 28.39268193,
		low: 18.40513852
	},
	"2026-01-29": {
		high: 28.70550435,
		low: 18.78752008
	},
	"2026-01-28": {
		high: 29.23017354,
		low: 19.01369284
	},
	"2026-01-27": {
		high: 29.7238367,
		low: 19.23818471
	},
	"2026-01-23": {
		high: 30.00930553,
		low: 19.64225401
	},
	"2026-01-22": {
		high: 29.2204461,
		low: 19.18480975
	},
	"2026-01-21": {
		high: 28.32710287,
		low: 18.59270326
	},
	"2026-01-20": {
		high: 28.31934697,
		low: 18.07675211
	},
	"2026-01-19": {
		high: 28.74232202,
		low: 18.2861746
	},
	"2026-01-16": {
		high: 28.83347473,
		low: 18.98183713
	},
	"2026-01-15": {
		high: 28.13969377,
		low: 18.5883267
	},
	"2026-01-14": {
		high: 27.84750937,
		low: 18.41003066
	},
	"2026-01-13": {
		high: 27.92766915,
		low: 18.38331073
	},
	"2026-01-12": {
		high: 28.141796,
		low: 18.2405003
	},
	"2026-01-09": {
		high: 26.01145638,
		low: 17.00944449
	},
	"2026-01-08": {
		high: 24.90473544,
		low: 16.15847737
	},
	"2026-01-07": {
		high: 25.77246153,
		low: 16.92896983
	},
	"2026-01-06": {
		high: 25.67629466,
		low: 16.71606402
	},
	"2026-01-05": {
		high: 25.11730944,
		low: 16.43876078
	},
	"2026-01-02": {
		high: 25.25935346,
		low: 16.44869821
	},
	"2025-12-31": {
		high: 24.89191353,
		low: 16.41846811
	},
	"2025-12-30": {
		high: 25.50405655,
		low: 16.62248641
	},
	"2025-12-29": {
		high: 25.11478482,
		low: 16.57184927
	},
	"2025-12-24": {
		high: 24.87446787,
		low: 16.38454061
	},
	"2025-12-23": {
		high: 25.18927466,
		low: 16.4980503
	},
	"2025-12-22": {
		high: 24.74860744,
		low: 16.2381957
	},
	"2025-12-19": {
		high: 24.50193673,
		low: 15.92744867
	},
	"2025-12-18": {
		high: 24.03760338,
		low: 15.75534004
	},
	"2025-12-17": {
		high: 24.20297223,
		low: 15.8870792
	},
	"2025-12-16": {
		high: 24.42087118,
		low: 15.94908175
	},
	"2025-12-15": {
		high: 24.70086719,
		low: 16.22820414
	},
	"2025-12-12": {
		high: 24.37820543,
		low: 15.99137902
	},
	"2025-12-11": {
		high: 24.4988508,
		low: 15.77562373
	},
	"2025-12-10": {
		high: 23.09386219,
		low: 15.05958974
	},
	"2025-12-09": {
		high: 23.25865526,
		low: 15.12330514
	},
	"2025-12-08": {
		high: 23.83121871,
		low: 15.54313564
	},
	"2025-12-05": {
		high: 23.89725891,
		low: 15.55717794
	},
	"2025-12-04": {
		high: 24.17304985,
		low: 15.68710387
	},
	"2025-12-03": {
		high: 23.67290367,
		low: 15.48097548
	},
	"2025-12-02": {
		high: 23.6231323,
		low: 15.46265248
	},
	"2025-12-01": {
		high: 23.77519917,
		low: 15.56756191
	},
	"2025-11-28": {
		high: 24.00911341,
		low: 15.68134501
	},
	"2025-11-27": {
		high: 23.69911608,
		low: 15.56944907
	},
	"2025-11-26": {
		high: 23.88398092,
		low: 15.34412217
	},
	"2025-11-25": {
		high: 22.62159593,
		low: 14.51714081
	},
	"2025-11-24": {
		high: 22.74716113,
		low: 14.27546582
	},
	"2025-11-21": {
		high: 21.73960747,
		low: 14.07485333
	},
	"2025-11-20": {
		high: 22.06859262,
		low: 14.18713631
	},
	"2025-11-19": {
		high: 21.52961293,
		low: 13.93336442
	},
	"2025-11-18": {
		high: 21.89533129,
		low: 13.86561183
	},
	"2025-11-17": {
		high: 20.34848996,
		low: 13.082656
	},
	"2025-11-14": {
		high: 20.22758319,
		low: 13.15041275
	},
	"2025-11-13": {
		high: 20.62267476,
		low: 13.26806344
	},
	"2025-11-12": {
		high: 20.58292798,
		low: 13.39505204
	},
	"2025-11-11": {
		high: 20.7259701,
		low: 13.49889401
	},
	"2025-11-10": {
		high: 21.0557959,
		low: 13.59281672
	},
	"2025-11-07": {
		high: 21.03090374,
		low: 13.44939277
	},
	"2025-11-06": {
		high: 20.81454998,
		low: 12.64832375
	},
	"2025-11-05": {
		high: 23.25475532,
		low: 14.87888148
	},
	"2025-11-04": {
		high: 24.52841208,
		low: 15.81758129
	},
	"2025-11-03": {
		high: 25.26687367,
		low: 16.53080569
	},
	"2025-10-31": {
		high: 25.68259888,
		low: 16.82860601
	},
	"2025-10-30": {
		high: 25.91840212,
		low: 16.92245187
	},
	"2025-10-29": {
		high: 27.01086349,
		low: 17.66549904
	},
	"2025-10-28": {
		high: 27.83387086,
		low: 17.80820115
	},
	"2025-10-27": {
		high: 27.37786169,
		low: 17.91099573
	},
	"2025-10-24": {
		high: 26.81533682,
		low: 17.50174223
	},
	"2025-10-23": {
		high: 26.18599532,
		low: 17.1551741
	},
	"2025-10-22": {
		high: 26.22163992,
		low: 17.12825436
	},
	"2025-10-21": {
		high: 25.92212982,
		low: 17.05826641
	},
	"2025-10-20": {
		high: 26.16255218,
		low: 17.19164122
	},
	"2025-10-17": {
		high: 26.22282256,
		low: 17.15458347
	},
	"2025-10-16": {
		high: 27.01490021,
		low: 17.62608121
	},
	"2025-10-15": {
		high: 26.92793438,
		low: 17.67593256
	},
	"2025-10-14": {
		high: 25.60278077,
		low: 16.6482925
	},
	"2025-10-13": {
		high: 25.77964744,
		low: 16.94679057
	},
	"2025-10-10": {
		high: 25.89676743,
		low: 16.89448387
	},
	"2025-10-09": {
		high: 26.50430269,
		low: 17.10851428
	},
	"2025-10-08": {
		high: 26.43224022,
		low: 17.12103253
	},
	"2025-10-07": {
		high: 24.19752762,
		low: 15.91589418
	},
	"2025-10-06": {
		high: 24.91695671,
		low: 16.1772296
	},
	"2025-10-03": {
		high: 23.95374013,
		low: 15.65759248
	},
	"2025-10-02": {
		high: 23.52041153,
		low: 15.52199433
	},
	"2025-10-01": {
		high: 23.17640836,
		low: 15.17058979
	},
	"2025-09-30": {
		high: 22.66515936,
		low: 14.81922215
	},
	"2025-09-29": {
		high: 22.64828294,
		low: 14.91212498
	},
	"2025-09-26": {
		high: 22.34019573,
		low: 14.61067653
	},
	"2025-09-25": {
		high: 21.88922015,
		low: 14.28945029
	},
	"2025-09-24": {
		high: 22.90181833,
		low: 14.74666509
	},
	"2025-09-23": {
		high: 23.59446032,
		low: 15.46572007
	},
	"2025-09-22": {
		high: 23.50736667,
		low: 15.39182243
	},
	"2025-09-19": {
		high: 23.490331,
		low: 15.19094133
	},
	"2025-09-18": {
		high: 23.24428314,
		low: 15.03606302
	},
	"2025-09-17": {
		high: 23.73251051,
		low: 15.65675374
	},
	"2025-09-16": {
		high: 24.19519758,
		low: 15.88419667
	},
	"2025-09-15": {
		high: 24.18958104,
		low: 15.91307536
	},
	"2025-09-12": {
		high: 24.61513919,
		low: 15.96341496
	},
	"2025-09-11": {
		high: 23.84534477,
		low: 15.71582633
	},
	"2025-09-10": {
		high: 23.66400603,
		low: 15.51677391
	},
	"2025-09-09": {
		high: 24.01105772,
		low: 15.66510893
	},
	"2025-09-08": {
		high: 24.64133909,
		low: 16.24831131
	},
	"2025-09-05": {
		high: 23.81454853,
		low: 15.61420641
	},
	"2025-09-04": {
		high: 23.25854116,
		low: 15.27636619
	},
	"2025-09-03": {
		high: 23.65259273,
		low: 15.5694579
	},
	"2025-09-02": {
		high: 23.97684455,
		low: 15.52041096
	},
	"2025-09-01": {
		high: 24.36979194,
		low: 15.78009538
	},
	"2025-08-29": {
		high: 24.87428807,
		low: 16.30560587
	},
	"2025-08-28": {
		high: 24.58942529,
		low: 16.07428545
	},
	"2025-08-27": {
		high: 24.36651231,
		low: 15.73182788
	},
	"2025-08-26": {
		high: 23.99439092,
		low: 15.46132073
	},
	"2025-08-25": {
		high: 24.78988602,
		low: 16.14815871
	},
	"2025-08-22": {
		high: 24.02631528,
		low: 15.65421622
	},
	"2025-08-21": {
		high: 23.23157111,
		low: 14.43500141
	},
	"2025-08-20": {
		high: 25.6291493,
		low: 15.98991303
	},
	"2025-08-19": {
		high: 34.7144876,
		low: 22.8177612
	},
	"2025-08-18": {
		high: 35.45654587,
		low: 23.05610188
	},
	"2025-08-15": {
		high: 35.88636245,
		low: 23.5027837
	},
	"2025-08-14": {
		high: 35.66439014,
		low: 23.29325612
	},
	"2025-08-13": {
		high: 34.77083129,
		low: 22.8586384
	},
	"2025-08-12": {
		high: 33.98745701,
		low: 22.30328976
	},
	"2025-08-11": {
		high: 34.24262355,
		low: 22.44811576
	},
	"2025-08-08": {
		high: 33.76565762,
		low: 22.24947808
	},
	"2025-08-07": {
		high: 33.6351302,
		low: 22.10509837
	},
	"2025-08-06": {
		high: 33.91192417,
		low: 21.84342942
	},
	"2025-08-05": {
		high: 32.11956522,
		low: 21.03519669
	},
	"2025-08-04": {
		high: 31.60815102,
		low: 20.66079893
	},
	"2025-08-01": {
		high: 31.53069153,
		low: 20.72002072
	},
	"2025-07-31": {
		high: 32.00143942,
		low: 21.14408359
	},
	"2025-07-30": {
		high: 32.84171528,
		low: 21.37991806
	},
	"2025-07-29": {
		high: 32.67657339,
		low: 21.44851692
	},
	"2025-07-28": {
		high: 32.60537947,
		low: 21.45008409
	},
	"2025-07-25": {
		high: 32.81185376,
		low: 21.53318934
	},
	"2025-07-24": {
		high: 33.50113331,
		low: 21.93874862
	},
	"2025-07-23": {
		high: 33.21363504,
		low: 21.67243155
	},
	"2025-07-22": {
		high: 31.81302801,
		low: 20.77350094
	},
	"2025-07-21": {
		high: 31.89740646,
		low: 21.04054689
	},
	"2025-07-18": {
		high: 32.19117905,
		low: 21.15881476
	},
	"2025-07-17": {
		high: 31.91613581,
		low: 20.71175578
	},
	"2025-07-16": {
		high: 31.66941847,
		low: 20.71616427
	},
	"2025-07-15": {
		high: 32.33200706,
		low: 21.26553922
	},
	"2025-07-14": {
		high: 33.1023653,
		low: 21.59191285
	},
	"2025-07-11": {
		high: 34.12400837,
		low: 22.27046085
	},
	"2025-07-10": {
		high: 33.87039403,
		low: 22.27989513
	},
	"2025-07-09": {
		high: 33.79121956,
		low: 21.90534694
	},
	"2025-07-08": {
		high: 34.14936757,
		low: 22.28563593
	},
	"2025-07-07": {
		high: 34.05414874,
		low: 22.22005956
	},
	"2025-07-04": {
		high: 34.30884511,
		low: 22.25424439
	},
	"2025-07-03": {
		high: 34.38481245,
		low: 22.30834921
	},
	"2025-07-02": {
		high: 35.27971245,
		low: 22.31379932
	},
	"2025-07-01": {
		high: 32.86308364,
		low: 21.32968363
	},
	"2025-06-30": {
		high: 33.80270569,
		low: 21.634995
	},
	"2025-06-27": {
		high: 31.06981239,
		low: 20.20125507
	},
	"2025-06-26": {
		high: 30.88108264,
		low: 20.19213151
	},
	"2025-06-25": {
		high: 30.78085216,
		low: 19.8589504
	},
	"2025-06-24": {
		high: 29.85639975,
		low: 19.5047283
	},
	"2025-06-23": {
		high: 28.86392849,
		low: 18.96359068
	},
	"2025-06-20": {
		high: 29.0946149,
		low: 19.00683054
	},
	"2025-06-19": {
		high: 29.25008263,
		low: 19.24081479
	},
	"2025-06-18": {
		high: 30.24186464,
		low: 19.44287192
	},
	"2025-06-17": {
		high: 30.77221877,
		low: 19.99948208
	},
	"2025-06-16": {
		high: 31.77025256,
		low: 20.82542664
	},
	"2025-06-13": {
		high: 32.05904863,
		low: 20.7085317
	},
	"2025-06-12": {
		high: 32.64191855,
		low: 21.20222576
	},
	"2025-06-11": {
		high: 32.95255176,
		low: 21.41733921
	},
	"2025-06-10": {
		high: 32.63667062,
		low: 21.33534987
	},
	"2025-06-06": {
		high: 31.78003233,
		low: 20.73491325
	},
	"2025-06-05": {
		high: 30.95691757,
		low: 20.28418143
	},
	"2025-06-04": {
		high: 30.15437326,
		low: 19.66425925
	},
	"2025-06-03": {
		high: 28.64803747,
		low: 18.45259247
	},
	"2025-06-02": {
		high: 28.68867361,
		low: 18.66867517
	},
	"2025-05-30": {
		high: 27.5889567,
		low: 18.03250223
	},
	"2025-05-29": {
		high: 26.81266304,
		low: 17.57109272
	},
	"2025-05-28": {
		high: 27.57521623,
		low: 17.78971584
	},
	"2025-05-27": {
		high: 27.75648006,
		low: 18.13835716
	},
	"2025-05-26": {
		high: 27.91312804,
		low: 18.34424635
	},
	"2025-05-23": {
		high: 28.89575811,
		low: 18.85861236
	},
	"2025-05-22": {
		high: 28.26814353,
		low: 18.43518839
	},
	"2025-05-21": {
		high: 28.49420849,
		low: 18.17245817
	},
	"2025-05-20": {
		high: 29.95781404,
		low: 19.61230007
	},
	"2025-05-19": {
		high: 30.09622894,
		low: 19.57881285
	},
	"2025-05-16": {
		high: 30.15936,
		low: 19.6096
	},
	"2025-05-15": {
		high: 30.73335725,
		low: 19.95080203
	},
	"2025-05-14": {
		high: 30.99898469,
		low: 20.23416314
	},
	"2025-05-13": {
		high: 31.31521577,
		low: 20.22473364
	},
	"2025-05-12": {
		high: 29.84979552,
		low: 19.49728001
	},
	"2025-05-09": {
		high: 29.38031311,
		low: 19.07912451
	},
	"2025-05-08": {
		high: 28.54217592,
		low: 18.45476535
	},
	"2025-05-07": {
		high: 28.90359047,
		low: 18.94020168
	},
	"2025-05-06": {
		high: 29.24511153,
		low: 19.23706147
	},
	"2025-05-05": {
		high: 29.68356927,
		low: 19.22512303
	},
	"2025-05-02": {
		high: 29.56883612,
		low: 19.25903975
	},
	"2025-05-01": {
		high: 28.5243767,
		low: 18.81710135
	},
	"2025-04-30": {
		high: 28.58624465,
		low: 18.80653773
	},
	"2025-04-29": {
		high: 28.39677121,
		low: 18.60192068
	},
	"2025-04-28": {
		high: 29.43653912,
		low: 18.79617544
	},
	"2025-04-24": {
		high: 28.41742987,
		low: 18.43736181
	},
	"2025-04-23": {
		high: 27.38701616,
		low: 17.76455102
	},
	"2025-04-22": {
		high: 26.27475192,
		low: 17.22625693
	},
	"2025-04-17": {
		high: 26.81491421,
		low: 17.28873127
	},
	"2025-04-16": {
		high: 26.23000936,
		low: 17.28796072
	},
	"2025-04-15": {
		high: 26.94842053,
		low: 17.60538816
	},
	"2025-04-14": {
		high: 27.24805981,
		low: 17.78587377
	},
	"2025-04-11": {
		high: 26.35928829,
		low: 17.02480689
	},
	"2025-04-10": {
		high: 27.06570433,
		low: 17.33698357
	},
	"2025-04-09": {
		high: 24.60156851,
		low: 15.81546978
	},
	"2025-04-08": {
		high: 24.87466806,
		low: 15.85672267
	},
	"2025-04-07": {
		high: 25.03949447,
		low: 15.25204653
	},
	"2025-04-04": {
		high: 26.30726851,
		low: 16.54262517
	},
	"2025-04-03": {
		high: 28.94219028,
		low: 18.33815239
	},
	"2025-04-02": {
		high: 27.91330302,
		low: 18.09503419
	},
	"2025-04-01": {
		high: 28.51315137,
		low: 18.38618777
	},
	"2025-03-31": {
		high: 29.42624077,
		low: 18.93792707
	},
	"2025-03-28": {
		high: 29.84571666,
		low: 19.36400558
	},
	"2025-03-27": {
		high: 29.54334878,
		low: 18.97450443
	},
	"2025-03-26": {
		high: 28.91074645,
		low: 18.94134982
	},
	"2025-03-25": {
		high: 29.29964399,
		low: 18.94836332
	},
	"2025-03-24": {
		high: 32.40042989,
		low: 19.9762427
	},
	"2025-03-21": {
		high: 35.51515531,
		low: 22.82920102
	},
	"2025-03-20": {
		high: 36.78699679,
		low: 23.4007434
	},
	"2025-03-19": {
		high: 38.66070804,
		low: 24.79737075
	},
	"2025-03-18": {
		high: 38.96748257,
		low: 25.56612895
	},
	"2025-03-17": {
		high: 38.76674474,
		low: 25.48710519
	},
	"2025-03-14": {
		high: 38.06693518,
		low: 25.00363572
	},
	"2025-03-13": {
		high: 37.66636922,
		low: 24.68359998
	},
	"2025-03-12": {
		high: 38.14301419,
		low: 24.82214837
	},
	"2025-03-11": {
		high: 38.6041151,
		low: 25.2372765
	},
	"2025-03-10": {
		high: 38.52692641,
		low: 25.23762289
	},
	"2025-03-07": {
		high: 39.06332753,
		low: 25.47224534
	},
	"2025-03-06": {
		high: 39.07238229,
		low: 25.63294144
	},
	"2025-03-05": {
		high: 38.89332269,
		low: 25.37148938
	},
	"2025-03-04": {
		high: 38.46134551,
		low: 25.25460292
	},
	"2025-03-03": {
		high: 38.62872507,
		low: 25.20477008
	},
	"2025-02-28": {
		high: 38.39660352,
		low: 25.01179333
	},
	"2025-02-27": {
		high: 39.1782393,
		low: 25.27113615
	},
	"2025-02-26": {
		high: 39.04678425,
		low: 25.03736308
	},
	"2025-02-25": {
		high: 37.63938752,
		low: 24.69712154
	},
	"2025-02-24": {
		high: 39.14682918,
		low: 24.90954104
	},
	"2025-02-21": {
		high: 39.33501106,
		low: 25.69968733
	},
	"2025-02-20": {
		high: 39.48585724,
		low: 25.71481583
	},
	"2025-02-19": {
		high: 40.64480521,
		low: 25.5536735
	},
	"2025-02-18": {
		high: 38.89255779,
		low: 25.3492507
	},
	"2025-02-17": {
		high: 39.01757239,
		low: 25.41199192
	},
	"2025-02-14": {
		high: 39.66217932,
		low: 25.93345187
	},
	"2025-02-13": {
		high: 40.23163439,
		low: 25.78542876
	},
	"2025-02-12": {
		high: 40.23583928,
		low: 26.25375955
	},
	"2025-02-11": {
		high: 40.45291759,
		low: 26.70174533
	},
	"2025-02-10": {
		high: 40.37574594,
		low: 26.69628458
	},
	"2025-02-07": {
		high: 40.92961421,
		low: 26.9904179
	},
	"2025-02-06": {
		high: 40.77406384,
		low: 26.72028148
	},
	"2025-02-05": {
		high: 39.75387942,
		low: 26.1204583
	},
	"2025-02-04": {
		high: 40.01675806,
		low: 26.01251852
	},
	"2025-02-03": {
		high: 39.47029268,
		low: 25.7257949
	},
	"2025-01-31": {
		high: 41.05959442,
		low: 26.93084066
	},
	"2025-01-30": {
		high: 40.3555379,
		low: 26.44685553
	},
	"2025-01-29": {
		high: 40.48245013,
		low: 26.61450092
	},
	"2025-01-28": {
		high: 40.9341518,
		low: 26.55431508
	},
	"2025-01-24": {
		high: 41.39706253,
		low: 26.72487761
	},
	"2025-01-23": {
		high: 41.19440132,
		low: 27.05063824
	},
	"2025-01-22": {
		high: 41.42447605,
		low: 27.08436577
	},
	"2025-01-21": {
		high: 41.52410575,
		low: 27.28640947
	},
	"2025-01-20": {
		high: 41.22769594,
		low: 27.19401712
	},
	"2025-01-17": {
		high: 40.89853978,
		low: 26.5179417
	},
	"2025-01-16": {
		high: 40.67114344,
		low: 26.09035961
	},
	"2025-01-15": {
		high: 38.79041446,
		low: 25.5215824
	},
	"2025-01-14": {
		high: 38.03614883,
		low: 24.76795522
	},
	"2025-01-13": {
		high: 37.39553156,
		low: 24.29288842
	},
	"2025-01-10": {
		high: 37.35666794,
		low: 24.46692148
	},
	"2025-01-09": {
		high: 37.49233618,
		low: 24.65551516
	},
	"2025-01-08": {
		high: 37.98360483,
		low: 24.50202298
	},
	"2025-01-07": {
		high: 37.56844131,
		low: 24.87121509
	},
	"2025-01-06": {
		high: 37.64163842,
		low: 24.59748157
	},
	"2025-01-03": {
		high: 37.32412302,
		low: 24.55475559
	},
	"2025-01-02": {
		high: 37.48976503,
		low: 24.64828921
	}
};
